class ConfigurationService extends BaseService
	@register()
	@inject 'ConfigurationRepository', 'parseBool'

	initialize: ->
		@configurations = null

	##
	# Check if configuration is enabled for specified value.
	#
	# Behaviour depends on type of `config`:
	#
	# boolean - than return direct value
	# string - check if that configuration value is enabled
	# array - first array element must be one of "OR" or "AND" in format `["OR", "Some.ConfigKey", "Another.ConfigKey", ...]`
	#     -- "OR" - one of configurations must be enabled
	#     -- "AND" - all of configurations must be enabled
	#
	# @param {string|bool|array} key
	#
	# @return {bool}
	##
	isEnabled: (config) ->
		if _.isBoolean config
			return config

		if _.isString(config)
			return @get(config, undefined)

		config = angular.copy(config)
		operator = config.shift()
		total = 0

		for configKey in config
			if @get(configKey, undefined)
				total++

		if operator.toUpperCase() == 'OR'
			return total > 0

		if operator.toUpperCase() == 'AND'
			return total == config.length

		console.error('Unknown operator ' + operator)

	isDisabled: (config) ->
		return !@isEnabled config

	getValue: (config) ->
		value = @get config, true

		if _.isEmpty(value)
			return null

		return value

	##
	# @param string key Key of configuration to look for
	# @param mixed returnAsValue If passed any defined value then return actual value, otherwise return bool
	#
	#	@return mixed
	#		- `false` if configuration key not found;
	#		- `string` value if {@param returnAsValue} is set
	#		- `true` if {@param returnAsValue} is not set and value is `"true"` or `true`
	##
	get: (key, returnAsValue) ->
		if angular.isDefined(returnAsValue) && @configurations
			if elem = _.find(@configurations.keys, (val) -> val.identifier == key)
				return elem.value
			else
				return false

		if @configurations
			configuration = _.find(@configurations.keys, (val) -> val.identifier == key)

			if configuration
				return @parseBool(configuration.value)
			else
				console.error key + ' does not exists'

				return false

	set: (config) ->
		configuration = _.find(@configurations.keys, (val) -> val.identifier == config.identifier)

		if !configuration?
			console.error config.identifier + ' does not exists'

			return

		configuration.id = config.id
		configuration.value = config.value
		configuration.label = config.label

	load: ->
		@ConfigurationRepository
			.getEntities()
			.then (response) =>
				@populate response

	populate: (configurations) ->
		@configurations =
			keys: configurations
			expires: moment().add(1, 'd').unix()

	clear:->
		@configurations = {}
